import CancelOrderSettings from "./routes/Orders/CancelOrderSettings.vue";
import Orders from "./routes/Orders/AllOrders.vue";
import DetailOrder from "./routes/Orders/routes/DetailOrder.vue";
import Reports from "./routes/Reports/Reports.vue";

const ordersRoutes = [
  {
    path: "orders",
    name: "Orders",
    component: Orders,
  },
  {
    path: "orders/:id",
    name: "Detail Order",
    component: DetailOrder,
  },
  {
    path: "orders/cancel-order-settings",
    name: "Cancel Order Settings",
    component: CancelOrderSettings,
  },
  {
    path: "reports",
    name: "Reports",
    component: Reports,
  },
];

export default ordersRoutes;
